/* ==============================================
   404.

   The SPA catch-all used to hand the React shell
   back with HTTP 200 for every unknown path, so a
   typo looked like a real page to a crawler and
   dead URLs accumulated in the index. This route
   catches everything unmatched, tells Google not to
   index it, and puts the reader back on a real page
   instead of leaving them on a dead end.

   The HTTP status itself is the host's job — see
   the note at the top of public/_redirects.
   ============================================== */

import { Link } from "react-router-dom";

import Seo from "../../seo/Seo";
import "../HomePage/homePage.css";
import "./notFound.css";

const DESTINATIONS = [
  { to: "/job-seekers", label: "For job seekers" },
  { to: "/career-centers", label: "For career centers" },
  { to: "/insights", label: "Research and reports" },
  { to: "/pricing", label: "Pricing" },
];

const NotFound = () => (
  <div className="home-page nf-page">
    <Seo
      path="/404"
      title="Page not found | RAIN"
      description="That page doesn't exist. Head back to RAIN to track applications, prep for interviews and run a better job search."
      noindex
    />

    <section className="nf-section">
      <div className="home-container nf-inner">
        <span className="nf-code">404</span>
        <h1 className="nf-title">We couldn&rsquo;t find that page</h1>
        <p className="nf-body">
          The link may be out of date, or the address may have a typo in it.
          Everything below is still where you left it.
        </p>

        <Link to="/" className="nf-cta">
          Back to the home page
        </Link>

        <ul className="nf-links">
          {DESTINATIONS.map(({ to, label }) => (
            <li key={to}>
              <Link to={to}>{label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  </div>
);

export default NotFound;
